module.exports = __webpack_public_path__ + "static/media/login_border.b4de6e9e.png";